<template>
  <v-layout row justify-center>
    <v-dialog :value="dialog" @input="reset" persistent width="35vmax">
      <v-form ref="refundForm">
        <v-card>
          <v-card-title class="pa-4">
            <div class="title primary--text">
              {{ $t('screener.seats.booking.refund.title') }}
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="px-4">
            <div class="mb-3 subheading">
              <div class="secondary--text text--darken-2 pb-1">
                {{ $t('screener.event.title') }}
              </div>
              <div class="secondary--text">{{ eventTitle }}</div>
            </div>
            <div>
              <v-radio-group v-model="type" column>
                <v-radio
                  :label="$t('screener.refund')"
                  value="refund"
                ></v-radio>
                <v-radio
                  :label="$t('screener.modification')"
                  value="modification"
                ></v-radio>
              </v-radio-group>
            </div>
            <v-textarea
              height="150px"
              outline
              name="refund-reason"
              :label="$t('booking.refund.reason')"
              v-model="reason"
              :hint="$t('booking.refund.reason.hint')"
              :rules="[rules.required]"
            ></v-textarea>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-4 py-3">
            <v-spacer></v-spacer>
            <v-btn color="" outline @click.stop="reset">{{
              $t('screener.btn.close')
            }}</v-btn>
            <v-btn
              :loading="loading"
              color="primary background--text"
              outline
              @click.stop="submitRefundModificationRequest"
              >{{ $t('screener.btn.submit') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import rules from '@/validation';
export default {
  name: 'RefundModification',
  props: {
    dialog: {
      type: Boolean,
      defaul: false,
    },
    eventTitle: {
      type: String,
      default: null,
    },
    screener_id: {
      type: Number,
      default: null,
    },
    booking_id: {
      type: Number,
      default: null,
    },
    purchase_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      rules,
      reason: null,
      type: 'refund',
      loading: false,
    };
  },
  watch: {
    reason() {
      this.$emit('update:reason', this.reason);
    },
    type() {
      this.$emit('update:type', this.type);
    },
  },
  methods: {
    reset() {
      this.reason = null;
      this.type = 'refund';
      this.dialog = false;
      this.loading = false;
      this.$emit('reset');
    },

    async submitRefundModificationRequest() {
      try {
        if (!this.$refs.refundForm.validate()) {
          return false;
        }

        this.loading = true;
        await this.$store.dispatch('consumer/submitRefundModificationRequest', {
          screener_id: this.screener_id,
          booking_id: this.booking_id,
          reason: this.reason,
          type: this.type,
          purchase_id: this.purchase_id,
        });

        this.reset();
        await this.$store.dispatch('app/showMessage', {
          message: 'Your request has been submited to admin',
          color: 'success',
        });
      } catch (error) {
        this.reset();
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>

<style></style>
